/* Bundles da Moopey (substitui o Kaching, 06/10/2026).
   Não se mexe no envio do tema (Symmetry): no momento do «submit» põem-se no formulário
   os campos items[n][id] / items[n][quantity] da barra escolhida, e o tema envia-os
   pelo AJAX dele como sempre (gaveta do carrinho incluída). */
(function () {
  'use strict';
  if (window.__mpBundle) return; window.__mpBundle = true;

  function dados(root) {
    try { return JSON.parse(root.querySelector('[data-mp-vars]').textContent); } catch (e) { return []; }
  }
  function variante(root, row) {
    var vs = dados(root);
    if (!row) return vs[0];
    var sel = [].map.call(row.querySelectorAll('select'), function (s) { return s.value; }).join('||');
    for (var i = 0; i < vs.length; i++) if (vs[i][1].join('||') === sel) return vs[i];
    return null;
  }
  function dinheiro(root, c) {
    var fmt = root.getAttribute('data-money') || '${{amount}}';
    var v = (c / 100).toFixed(2), n0 = Math.round(c / 100).toString();
    var sep = function (x, m, d) { var p = x.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, m); return p.join(d); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return sep(n0, ',', '.');
      if (k === 'amount_with_comma_separator') return sep(v, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return sep(n0, '.', ',');
      return sep(v, ',', '.');
    });
  }
  function conta(bar, v) {
    var q = +bar.dataset.q || 1, t = bar.dataset.tipo, val = +bar.dataset.valor || 0;
    var p = v[3], cheio = p * q, risc = v[4] > p ? v[4] * q : cheio, pago = cheio;
    if (t === 'specific') pago = Math.round(val * 100);
    else if (t === 'percentage') pago = Math.ceil(p * (100 - val) / 100) * q;
    else if (t === 'amount') pago = (p - Math.round(val * 100)) * q;
    // noutra moeda (AUD, CAD, NZD…) conta-se como o carrinho: preço da variante já na moeda do cliente menos o
    // desconto real do pack — % arredondada para baixo em cada unidade «levada», ou valor fixo × taxa (ao cêntimo)
    var pk = bar.dataset.pk, cur = window.Shopify && Shopify.currency, loja = (bar.closest('[data-mp-bundle]') || {}).dataset;
    if (pk && cur && loja && loja.loja && cur.active && cur.active !== loja.loja && q > 1) {
      var a = pk.split(':'), taxa = +cur.rate || 1, d = 0;
      if (a[0] === 'up') d = q * Math.floor(p * +a[1] + 1e-7);            // % em cada unidade, arredondada para baixo
      else if (a[0] === 'uv') d = q * Math.round(+a[1] * taxa + 1e-7);     // valor fixo em cada unidade, convertido ao cêntimo
      else if (a[0] === 'pct') d = (q - 1) * Math.floor(p * +a[1] + 1e-7); // (antigo: compra 1, leva N−1)
      else d = Math.round(+a[1] * taxa + 1e-7);
      pago = cheio - d;
    }
    pago = Math.max(0, Math.min(pago, cheio));
    return [pago, risc];
  }
  // unidades de preços diferentes na barra escolhida: soma unidade a unidade, como o carrinho (06/10)
  function mistura(root, bar, v) {
    var sel = root.querySelector('.mp-b__bar input:checked'); if (!sel || sel.closest('.mp-b__bar') !== bar) return null;
    var rows = bar.querySelectorAll('.mp-b__row'), q = +bar.dataset.q || 1, pk = bar.dataset.pk;
    if (rows.length !== q || q < 2 || !pk) return null;
    var a = pk.split(':'); if (a[0] !== 'up' && a[0] !== 'uv') return null;
    var cur = window.Shopify && Shopify.currency, loja = (root.dataset || {}).loja;
    var taxa = (cur && loja && cur.active && cur.active !== loja) ? (+cur.rate || 1) : 1;
    var ws = [], dif = false;
    for (var i = 0; i < rows.length; i++) { var w = variante(root, rows[i]); if (!w) return null; ws.push(w); if (w[3] !== ws[0][3]) dif = true; }
    if (!dif) return null;
    var pago = 0, risc = 0;
    ws.forEach(function (w) {
      var p = w[3], off = a[0] === 'up' ? Math.floor(p * +a[1] + 1e-7) : Math.round(+a[1] * taxa + 1e-7);
      pago += Math.max(0, p - off); risc += w[4] > p ? w[4] : p;
    });
    return [pago, risc];
  }
  function precos(root) {
    var bars = root.querySelectorAll('.mp-b__bar');
    var sel = root.querySelector('.mp-b__bar input:checked');
    var ref = sel ? sel.closest('.mp-b__bar').querySelector('.mp-b__row') : null;
    var v = variante(root, ref);
    if (!v) { var f = root.closest('form'), fid = f && f.querySelector('[name="id"]'), vid = fid ? +fid.value : 0; v = dados(root).filter(function (x) { return x[0] === vid; })[0] || dados(root)[0]; }
    if (!v) return;
    [].forEach.call(bars, function (bar) {
      var el = bar.querySelector('[data-mp-preco]'); if (!el) return;
      var c = mistura(root, bar, v) || conta(bar, v);
      el.innerHTML = '<b>' + dinheiro(root, c[0]) + '</b>' + (c[1] > c[0] ? '<s>' + dinheiro(root, c[1]) + '</s>' : '');
      var pct = c[1] > 0 ? Math.round(Math.round((c[1] - c[0]) / c[1] * 10000) / 100) : 0;
      [].forEach.call(bar.querySelectorAll('[data-tpl]'), function (t) {
        var raw = t.getAttribute('data-tpl'); if (raw.indexOf('{{') < 0) return;
        t.textContent = raw.replace(/\{\{\s*saved_percentage\s*\}\}/g, pct + '%').replace(/\{\{\s*saved_total\s*\}\}/g, dinheiro(root, c[1] - c[0])).replace(/\{\{\s*quantity\s*\}\}/g, bar.dataset.q);
      });
    });
  }
  function sincroniza(root) {
    // o seletor escondido do tema segue a 1.ª unidade (imagem da variante e validação do tema)
    var form = root.closest('form'); if (!form) return;
    var orig = form.querySelector('.original-selector');
    var sel = root.querySelector('.mp-b__bar input:checked'); if (!sel || !orig) return;
    var row = sel.closest('.mp-b__bar').querySelector('.mp-b__row'); if (!row) return;   // sem seletores: manda o do tema
    var v = variante(root, row);
    if (v && orig.value !== String(v[0])) { orig.value = String(v[0]); orig.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && !e.target.closest('[data-mp-bundle]')) {
      var f = e.target.closest('form'), r0 = f && f.querySelector('.mp-b--semvars');
      if (r0) setTimeout(function () { precos(r0); }, 0);
      return;
    }
    var root = e.target.closest && e.target.closest('[data-mp-bundle]'); if (!root) return;
    if (e.target.matches('input[type=radio]')) {
      // a mesma variante passa para as linhas da barra nova
      var bar = e.target.closest('.mp-b__bar'), prev = root.__mpUlt;
      if (prev && prev !== bar) {
        var de = prev.querySelectorAll('.mp-b__row'), para = bar.querySelectorAll('.mp-b__row');
        [].forEach.call(para, function (r, i) {
          var src = de[Math.min(i, de.length - 1)]; if (!src) return;
          var a = src.querySelectorAll('select'), b2 = r.querySelectorAll('select');
          [].forEach.call(b2, function (s, k) { if (a[k]) s.value = a[k].value; });
        });
      }
      root.__mpUlt = bar;
    }
    var aviso = root.querySelector('.mp-b__aviso'); if (aviso) aviso.remove();
    precos(root); sincroniza(root);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target, root = form.querySelector && form.querySelector('[data-mp-bundle]'); if (!root) return;
    [].forEach.call(form.querySelectorAll('.mp-b__item'), function (x) { x.remove(); });
    var sel = root.querySelector('.mp-b__bar input:checked'); if (!sel) return;
    var bar = sel.closest('.mp-b__bar'), q = +bar.dataset.q || 1, rows = bar.querySelectorAll('.mp-b__row'), itens = [];
    if (rows.length) {
      for (var i = 0; i < rows.length; i++) {
        var v = variante(root, rows[i]);
        if (!v || !v[2]) {
          e.preventDefault(); e.stopImmediatePropagation();
          var a = root.querySelector('.mp-b__aviso') || document.createElement('span');
          a.className = 'mp-b__aviso'; a.textContent = root.getAttribute('data-erro'); rows[i].after(a);
          return;
        }
        var ja = itens.filter(function (x) { return x[0] === v[0]; })[0];
        if (ja) ja[1]++; else itens.push([v[0], 1]);
      }
    } else {
      // oferta sem seletores na barra (como no Kaching): a variante escolhida no seletor do tema, q vezes
      var fid = form.querySelector('[name="id"]'), vid = fid ? +fid.value : 0;
      var v0 = dados(root).filter(function (x) { return x[0] === vid; })[0] || dados(root)[0]; if (!v0) return; itens.push([v0[0], q]);
    }
    var orig = form.querySelector('[name="id"]');
    // fica com o nome (o tema valida por ele), mas desligado para não ir no envio
    if (orig) { orig.value = String(itens[0][0]); orig.disabled = true; orig.setAttribute('data-mp-off', '1'); }
    itens.forEach(function (it, n) {
      [['id', it[0]], ['quantity', it[1]]].forEach(function (kv) {
        var h = document.createElement('input'); h.type = 'hidden'; h.className = 'mp-b__item';
        h.name = 'items[' + n + '][' + kv[0] + ']'; h.value = kv[1]; form.appendChild(h);
      });
    });
    // o tema lê o formulário já a seguir (no mesmo evento); depois repõe-se como estava
    setTimeout(function () {
      [].forEach.call(form.querySelectorAll('.mp-b__item'), function (x) { x.remove(); });
      var o = form.querySelector('[data-mp-off]'); if (o) { o.disabled = false; o.removeAttribute('data-mp-off'); }
    }, 0);
  }, true);

  function arranca() {
    [].forEach.call(document.querySelectorAll('[data-mp-bundle]'), function (root) {
      var s = root.querySelector('.mp-b__bar input:checked');
      if (!s) { s = root.querySelector('.mp-b__bar input'); if (s) s.checked = true; }
      root.__mpUlt = s ? s.closest('.mp-b__bar') : null;
      precos(root); sincroniza(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca); else arranca();
})();
